import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { backUrl } from "../config";

const redPath = "nomenklaturaApi";
const tagApi = "nomenklaturs";

export const nomenklaturaApi = createApi({
  reducerPath: redPath,
  baseQuery: fetchBaseQuery({
    baseUrl: backUrl,
    tagTypes: [tagApi],
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.accessToken;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getNomenklaturs: build.query({
      query: (param) => `${tagApi}${param ? param : ""}`,
      providesTags: [tagApi],
    }),
    createNomenklatura: build.mutation({
      query: (newNomenklatura) => ({
        url: tagApi,
        method: "POST",
        body: {
          data: {
            ...newNomenklatura,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
    updateNomenklatura: build.mutation({
      query: (newData) => ({
        url: `${tagApi}/${newData.id}`,
        method: "PUT",
        body: {
          data: {
            ...newData.updated,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
  }),
});

export const {
  useGetNomenklatursQuery,
  useCreateNomenklaturaMutation,
  useUpdateNomenklaturaMutation,
} = nomenklaturaApi;
